import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { isOnline } from '../lib/cache'

interface CacheContextType {
  isOnline: boolean
  setIsOnline: (online: boolean) => void
}

const CacheContext = createContext<CacheContextType | undefined>(undefined)

export const CacheProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [online, setOnline] = useState(isOnline())

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true)
    }

    const handleOffline = () => {
      setOnline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return (
    <CacheContext.Provider value={{ isOnline: online, setIsOnline: setOnline }}>
      {children}
    </CacheContext.Provider>
  )
}

export const useCache = () => {
  const context = useContext(CacheContext)
  if (!context) {
    throw new Error('useCache must be used within CacheProvider')
  }
  return context
}

